import type { JSX } from "react";

export function AdminPagination({
  offset,
  limit,
  total,
  onPrev,
  onNext,
}: {
  offset: number;
  limit: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}): JSX.Element | null {
  if (total <= limit) return null;
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);
  const atStart = offset === 0;
  const atEnd = offset + limit >= total;
  return (
    <div className="flex items-center justify-center gap-4 pt-3 text-xs text-[var(--cs-navy)]">
      <button
        type="button"
        onClick={onPrev}
        disabled={atStart}
        className="rounded-lg border border-[rgba(10,52,96,0.10)] bg-white px-3 py-1.5 font-medium hover:bg-[var(--cs-ivory)] disabled:opacity-40"
      >
        ◀ Vorige
      </button>
      <span className="tabular-nums text-[var(--cs-ink-muted)]">
        {from}–{to} van {total}
      </span>
      <button
        type="button"
        onClick={onNext}
        disabled={atEnd}
        className="rounded-lg border border-[rgba(10,52,96,0.10)] bg-white px-3 py-1.5 font-medium hover:bg-[var(--cs-ivory)] disabled:opacity-40"
      >
        Volgende ▶
      </button>
    </div>
  );
}
